export const municipalityMapper = municipality => {
  const { id, description } = municipality
  return { id, label: description, value: id }
}
